<!-- * the button is w-full: use the container with self-center AND/OR max-w-fit to change the width behavior -->
<button 
  matRipple
  class="border-[3px] border-accent-500 rounded cursor-pointer
    p-[5px] md:p-[10px] w-full outline-none duration-500
    flex justify-center items-center gap-3"
  [disabled]="disabled"
  [ngClass]="{ 
    'animate-[hl_0.6s_ease-out_0.5s_infinite_alternate]': animate && !disabled,
    'hover:animate-[hl_0.6s_ease-out_0.5s_infinite_alternate]': !animate && !disabled,
    'bg-accent-500 text-white hover:bg-transparent hover:text-accent-500': reverseHighlight && !disabled, 
    'bg-transparent text-accent-500 hover:bg-accent-500 hover:text-white': !reverseHighlight && !disabled,
    'border-0 bg-gray-300 text-gray-400 cursor-auto': disabled
  }">
  <ng-content></ng-content>
</button>
